import { CV_CONFIG, createApiHeaders } from '../config/cvConfig.js'

// Emits 'upgrade-required' with limit data when any API call returns 402
export const apiEvents = new EventTarget()

// For callers that fetch outside ApiService (wizard, duplicate modal):
// dispatches the global event that SpaApp's UpgradeModal listens for.
export function reportUpgradeRequired(detail = {}) {
  apiEvents.dispatchEvent(new CustomEvent('upgrade-required', { detail }))
}

async function handleResponse(response) {
  if (response.status === 402) {
    const data = await response.json().catch(() => ({}))
    reportUpgradeRequired(data)
    throw new Error(data.message || 'Upgrade required')
  }
  return response
}

export class ApiService {
  static async saveCv(cvData, cvId = null, status = 'draft') {
    const endpoint = cvId ? `${CV_CONFIG.api.cvs}/${cvId}` : CV_CONFIG.api.cvs
    const method = cvId ? 'PATCH' : 'POST'
    
    const response = await fetch(endpoint, {
      method,
      headers: createApiHeaders(),
      body: JSON.stringify({
        cv: cvData,
        status
      })
    })

    await handleResponse(response)

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}))
      throw new Error(errorData.message || `Failed to save CV: ${response.status}`)
    }

    return await response.json()
  }

  static async loadCv(cvId) {
    const response = await fetch(`${CV_CONFIG.api.cvs}/${cvId}`, {
      method: 'GET',
      headers: createApiHeaders()
    })

    if (!response.ok) {
      const errorText = await response.text()
      throw new Error(`Failed to load CV: ${response.status} - ${errorText}`)
    }

    return await response.json()
  }

  static async saveDraft(cvData, draftName = null) {
    const response = await fetch(CV_CONFIG.api.saveDraft, {
      method: 'POST',
      headers: createApiHeaders(),
      body: JSON.stringify({
        ...cvData,
        draft_name: draftName
      })
    })

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}))
      throw new Error(errorData.error || 'Failed to save draft')
    }

    return await response.json()
  }

  static async optimizeBullets(payload) {
    const response = await fetch(CV_CONFIG.api.optimizeBullets, {
      method: 'POST',
      headers: createApiHeaders(),
      body: JSON.stringify(payload)
    })

    const data = await response.json().catch(() => ({}))
    if (!response.ok) {
      // The AI gate returns upgrade_required for both free users (402) and
      // guests (401) — either opens the global UpgradeModal (AI funnel).
      if (data.upgrade_required) reportUpgradeRequired(data)
      throw new Error(data.message || `Failed to optimize bullets: ${response.status}`)
    }

    return data
  }

}